import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';

import Dialog, { DialogTitle, DialogActions, DialogContent, DialogContentText } from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';

import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';
import { roleToString } from '../../../utils/user-utils';
import * as userActions from '../user.actions';

const constraints = {
  firstName: {
    presence: true,
  },
  lastName: {
    presence: true,
  },
  email: {
    email: true,
  },
  role: {
    length: { minimum: 1 },
  },
};
const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: 0,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

const availableRoles = ['guest', 'inspector', 'department'];
const defaultMessage =
  'Käyttäjän kutsuminen palveluun ei onnistunut. Tarkista verkkoyhteytesi ja yritä myöhemmin uudelleen.';

class AddUserDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        firstName: '',
        lastName: '',
        email: '',
        role: '',
      },
      errors: {},
      touchedFields: [],
      isValid: false,
      submitted: false,
      submitSuccess: false,
      message: defaultMessage,
    };
  }

  handleCancel = () => {
    this.props.onRequestClose();
    this.setState({
      submitted: false,
      submitSuccess: false,
    });
  };
  handleAdd = () => {
    if (this.state.isValid) {
      const { createUser } = this.props;
      createUser(this.state.data).then(action => {
        if (action && action.response && action.response.status === 'ok') {
          this.setState({
            submitted: true,
            submitSuccess: true,
          });
        } else {
          let message = '';
          switch (action && action.error && action.error.message) {
            case 'User validation failed: email: The specified email address is already in use.':
              const email = action.error.errors.email.value;
              message = `Sähköpostiosoite ${email} on jo käytössä. Voit rekisteröityä kerran yhdellä sähköpostiosoitteella.`;
              break;
            default:
              message = defaultMessage;
          }

          this.setState({
            submitted: true,
            submitSuccess: false,
            message: message,
          });
        }
      });
    }
  };
  handleRetry = () => {
    this.setState({
      data: {
        firstName: '',
        lastName: '',
        email: '',
        role: '',
      },
      errors: {},
      touchedFields: [],
      isValid: false,
      submitted: false,
      submitSuccess: false,
    });
  };
  validate = () => {
    const { data } = this.state;
    const errors =
      validate(data, constraints, {
        format: 'custom',
      }) || {};
    const isValid = isEmpty(errors);
    this.setState({
      errors,
      isValid,
    });
  };
  onInputChange = event => {
    const { name } = event.target;
    if (name === '') return;
    this.updateData(event);
  };
  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  updateTouchedfields(event) {
    const { name } = event.target;
    if (name === '') return;
    const touchedFields = [...this.state.touchedFields.filter(item => item !== name), name];
    this.setState({
      touchedFields,
    });
  }
  handleChange = name => event => {
    //List select doesnt contain name prop
    const updatedEvent = { ...event, target: { ...event.target, name: name } };
    this.updateData(updatedEvent);
    this.updateTouchedfields(updatedEvent);
  };

  updateData(event) {
    const target = event.target;
    const { value, name } = target;
    if (name === '') return;
    var newData = {
      ...this.state.data,
      [name]: value,
    };

    this.setState(
      {
        data: { ...newData },
      },
      () => {
        this.validate();
      }
    );
  }

  handleRequestClose = () => {
    this.props.onRequestClose();
  };

  renderForm() {
    const { isValid, errors, touchedFields } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <DialogTitle>Lisää uusi käyttäjä</DialogTitle>
        <DialogContent>
          <DialogContentText>Täytä uuden käyttäjän tiedot.</DialogContentText>
          <form className={classes.container} autoComplete="off">
            <TextField
              fullWidth
              name="firstName"
              label="Etunimi"
              margin="normal"
              onBlur={this.onBlur}
              onChange={this.onInputChange}
              value={this.state.data.firstName}
              error={errors['firstName'] && touchedFields.indexOf('firstName') > -1}
            />
            <TextField
              fullWidth
              name="lastName"
              label="Sukunimi"
              margin="normal"
              onBlur={this.onBlur}
              error={errors['lastName'] && touchedFields.indexOf('lastName') > -1}
              onChange={this.onInputChange}
              value={this.state.data.lastName}
            />
            <TextField
              fullWidth
              name="email"
              label="Sähköpostiosoite"
              margin="normal"
              type="email"
              onBlur={this.onBlur}
              error={errors['email'] && touchedFields.indexOf('email') > -1}
              onChange={this.onInputChange}
              value={this.state.data.email}
            />
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="role-select">Käyttäjäoikeudet</InputLabel>
              <Select
                name="role"
                value={this.state.data.role}
                onChange={this.handleChange('role')}
                input={<Input id="role-select" />}
                error={errors['role'] && touchedFields.indexOf('role') > -1}
              >
                <MenuItem value="" />
                {availableRoles.map((role, index) => {
                  return (
                    <MenuItem key={index} value={role}>
                      {roleToString(role)}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Peruuta
          </Button>
          <Button disabled={!isValid} onClick={this.handleAdd} color="primary">
            Lähetä kutsu
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <DialogTitle>Kutsu lähetetty</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Käyttäjän kutsuminen onnistui. Käyttäjä saa sähköpostiinsa viestin, jossa olevasta linkistä hän voi
            rekisteröityä palveluun.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Takaisin
          </Button>
          <Button onClick={this.handleRetry} color="primary">
            Kutsu lisää käyttäjiä
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderFailure() {
    return (
      <div>
        <DialogTitle>Lähetys/lisäys ei onnistunut</DialogTitle>
        <DialogContent>
          <DialogContentText>{this.state.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Takaisin</Button>
        </DialogActions>
      </div>
    );
  }
  render() {
    const { open } = this.props;
    const { submitted, submitSuccess } = this.state;
    return (
      <Dialog onRequestClose={this.handleRequestClose} open={open}>
        {!submitted ? this.renderForm() : submitSuccess ? this.renderSuccess() : this.renderFailure()}
      </Dialog>
    );
  }
}

export default connect(null, Object.assign({}, userActions))(withStyles(styles)(AddUserDialog));



// WEBPACK FOOTER //
// ./src/modules/user/components/AddUserDialog.js